<template>
  <div class="container solicitudPerfil">
    <div class="title">{{$t('PERFIL_edicion')}}</div>
    <div class="card_container">
      <el-card>
        <el-row class="form" :gutter="20">
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="24">
                <div class="label" style="font-weight:bold !important;">{{$t('PERFIL_instrucciones')}}</div>
              </el-col>
            </el-row>
            
            <el-row :gutter="20">
              <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="4">
                <div class="label">{{$t('PERFIL_mensaje')}}</div>
              </el-col>
              <el-col :xs="24" :sm="20" :md="20" :lg="20" :xl="20">
                <editor-content class="textarea" :editor="editor" />
              </el-col> 
            </el-row>

            <el-row>
              <el-upload
              class="upload"
              :auto-upload="false"
              accept="image/*"
              :limit="1"
              :file-list="imagen"
              :on-change="setImagen"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :on-error="handleError"
              :on-exceed="handleExceed">
              <div class="link">{{$t('PERFIL_upload_img')}}</div>
              </el-upload>
            </el-row>
            <el-row style="text-align:center;">
              <el-button class="btn" type="primary" @click="onEnviar">{{$t('GENERAL_enviar')}}</el-button>
            </el-row>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
  import { useEditor, EditorContent } from '@tiptap/vue-3'
  import StarterKit from '@tiptap/starter-kit'
  import { mapState } from 'vuex'
  import { mostrarMensajeInternacionalizado } from '../MensajeInternacionalizado'
  import { showError, showSuccess } from '../Mensaje'

  export default {
    components: { EditorContent },
    setup() {
      const editor = useEditor({
        extensions: [StarterKit],
        content: '<p></p>',
      })

      return {
        editor
      }
    },
    data() {
      return {
        imagen: [],
        enviando: false
      }
    },
    computed: {
      ...mapState({
        perfil: state => state.perfil.perfil
      })
    },
    methods: {
      setImagen(file, fileList) {
        this.imagen = fileList
      },
      onEnviar() {
        // indico que se está enviando el mensaje
        this.enviando = true

        // validaciones
        let valida = true
        let errorMsg = ''

        if(this.editor?.isEmpty)
        {
          errorMsg = this.$t('PERFIL_missing_mensaje')
          valida = false
        }

        if(!valida) {
          showError(errorMsg)
          this.enviando = false
          return
        }
        
        // armo el payload
        let payload = new FormData();
        payload.append('CodigoPerfil', this.perfil.Codigo)
        payload.append('DescripcionPerfil', this.perfil.Empresa.RazonSocial)
        payload.append('Nota', this.editor?.getHTML() ?? '')

        // si se adjuntó una imagen, la agrego al payload
        if(this.imagen !== undefined && this.imagen.length > 0)
          payload.append("FotoNegocio", this.imagen[0].raw);


        // envío el formulario al servidor
        this.$store.dispatch('perfil/solicitarActualizacion', payload)
        .then(data => {
          // éxito
          if(data === 0)
            showSuccess(this.$t('PERFIL_success'))

          // error
          else
            mostrarMensajeInternacionalizado(data)
        })
        .finally(() => { 
          this.enviando = false 
          this.$router.push({ name: 'Perfil' })
        })
      }
    },
    created() {
      this.$store.dispatch('perfil/getPerfil', {codigo: "1234"})
    }
  }
</script>

<style scoped>

  .container {
    padding: 20px 40px;
  }

  .title {
    font-size: 22px;
    font-weight: bold;
    text-align: left;
    color: var(--main-color);
    margin-bottom: 20px;
  }

  .card_container {
    max-width: 800px;
  }

  .form {
    text-align: left;
    /* padding: 20px 60px; */
  }

  .label {
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 20px;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
    display: inline-block;
  }

  .textarea {
    display: inline-block;
    vertical-align: top;
    min-width: 80%;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding: 5px 15px;
  }

  .upload {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 300px;
  }

  .link {
    cursor: pointer;
    color: #409EFF;
    display: inline-block;
  }

</style>

<style>

  .ProseMirror {
    padding: 0px;
    margin-top: 0px;
    outline: none;
  }

  .solicitudPerfil p {
    margin: 0px;
    font-size: 14px;
    color: #606266;
    min-height: 100px;
  }

</style>

